import { render, staticRenderFns } from "./AlgOfferLink.vue?vue&type=template&id=002db54d&scoped=true&"
import script from "./AlgOfferLink.vue?vue&type=script&lang=js&"
export * from "./AlgOfferLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002db54d",
  null
  
)

export default component.exports